"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var GroupSpacer_1 = require("./GroupSpacer");
var getClassNames = Utilities_1.classNamesFunction();
var GroupFooterBase = /** @class */ (function (_super) {
    tslib_1.__extends(GroupFooterBase, _super);
    function GroupFooterBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupFooterBase.prototype.render = function () {
        var _a = this.props, group = _a.group, groupLevel = _a.groupLevel, footerText = _a.footerText, indentWidth = _a.indentWidth, styles = _a.styles, theme = _a.theme;
        var classNames = getClassNames(styles, { theme: theme });
        if (group && footerText) {
            return (React.createElement("div", { className: classNames.root },
                React.createElement(GroupSpacer_1.GroupSpacer, { indentWidth: indentWidth, count: groupLevel }),
                footerText));
        }
        return null;
    };
    return GroupFooterBase;
}(React.Component));
exports.GroupFooterBase = GroupFooterBase;
//# sourceMappingURL=GroupFooter.base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/GroupedList/GroupFooter.base.js
// module id = 896
// module chunks = 0